export const GetLogoConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}logo/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetLogoConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}logo/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ToggleLogoVisibility = async (visible) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}logo/toggle-visibility`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ visible })
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};
